export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пошук"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви в демо-режимі. Баланси та операції — навчальні."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перейти в робочий кабінет"])}
}